import { ValidationResultFail } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getProductRef } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
export const entityIsAdjustable = (entity) => entity.hasComponent(COMPONENT_IDS.ADJUSTABLE_COMPONENT);
export const entityIsAdjustableShelf = (entity) => entityIsAdjustable(entity) && entity.hasComponent(COMPONENT_IDS.INSERT);
export const isInsertBeingMoved = ({ guest }) => guest.hasComponent(COMPONENT_IDS.INSERT);
export const generateValidationFail = (guestEntity, msg) => new ValidationResultFail(msg, getProductRef(guestEntity));
